module.exports = __webpack_public_path__ + "img/banker_mark.f0abb5de.svg";